import React from 'react'
import { Route, Switch } from 'utils-next/routes'

import { ScoutingCampaignDetailsView, ScoutingCampaignListView } from './scenes'
import {
  SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH,
  SCOUTING_CAMPAIGN_MANAGER_LIST_PATH,
} from './ScoutingCampaignManager.routes'

export function ScoutingCampaignManager() {
  return (
    <Switch>
      <Route path={SCOUTING_CAMPAIGN_MANAGER_LIST_PATH} component={ScoutingCampaignListView} exact />
      <Route path={SCOUTING_CAMPAIGN_MANAGER_DETAILS_PATH} component={ScoutingCampaignDetailsView} />
    </Switch>
  )
}
